<template>
  <div class="subscription-details">
    <dl>
      <dt>My Account</dt>
      <dd>{{ email }}</dd>
      <dt>Current Status</dt>
      <dd>{{ status }}</dd>
      <dd v-if="hasAppManagedSubscription" class="status-note">
        {{ placeholder }}
      </dd>
      <dd v-if="statusDetail" class="small">{{ statusDetail }}</dd>
      <dt v-if="hasUpcomingBilling">Upcoming</dt>
      <dd v-if="billingFrequency">Billing Cycle: {{ billingFrequency }}</dd>
      <dd v-if="billingAmount">Amount: {{ billingAmount }}</dd>
      <dd v-if="billingDate" class="small">Date: {{ billingDate }}</dd>
    </dl>
  </div>
</template>

<script>
import dayjs from "dayjs";

export default {
  name: "SubscriptionDetails",
  components: {},
  props: ["placeholder"],
  data() {
    const subscription = this.$user.user["subscription-info"];
    const billingAmount =
      subscription && this.formatDollars(this.$user.getSubscriptionPricing());
    const billingDate =
      subscription && this.formatDate(subscription["next-billing-date"]);
    const status =
      (subscription && subscription.status) ||
      (this.$user.user.premium && "Premium") ||
      "Free";
    return {
      email: this.$user.user.email,
      status,
      statusDetail: subscription && this.getStatusDetailMapping(subscription),
      billingFrequency: subscription && subscription["billing-frequency"],
      billingAmount,
      billingDate,
      hasUpcomingBilling:
        (subscription && subscription["billing-frequency"]) ||
        billingAmount ||
        billingDate,
      canCancel:
        subscription &&
        subscription.platform === "web" &&
        !subscription["subscription-end-date"],
      hasAppManagedSubscription:
        this.$user.user.premium && !this.$user.user["stripe-subscription-id"],
    };
  },
  methods: {
    getStatusDetailMapping(subscription) {
      switch (subscription.status) {
        case "In Trial":
          return `Free trial ends ${this.formatDate(
            subscription["trial-end"]
          )}`;
        case "Canceled":
          return `Premium access ends ${this.formatDate(
            subscription["subscription-end-date"]
          )}`;

        case "Expired":
          return `Subscription ended ${this.formatDate(
            subscription["subscription-end-date"]
          )}`;
        default:
          return null;
      }
    },
    formatDate(dateString) {
      if (!dateString) return null;
      try {
        const date = new Date(dateString);
        return dayjs(date).format("MM/DD/YYYY");
      } catch (e) {
        return null;
      }
    },
    formatDollars(amount) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      if (amount === null || Number.isNaN(Number(amount))) return null;

      return formatter.format(amount);
    },
  },
};
</script>

<style lang="scss">
@import "@/style/variables";
@import "@/style/mixins";

.subscription-details {
  text-align: left;

  dl {
    padding-bottom: 30px;

    &:not(:last-child) {
      border-bottom: 1px solid $light-gray;
    }

    &:not(:first-child) {
      padding-top: 30px;
    }
  }

  dl {
    margin: 0;
    font-size: 16.5px;
  }

  dt,
  header {
    font-size: 16.5px;
    font-weight: 700;

    &:not(:first-child) {
      margin-top: 30px;
      border-top: 1px solid $light-gray;
      padding-top: 30px;
    }
  }

  dd {
    color: $medium-gray;
    font-weight: 700;
    padding-top: 20px;
    margin: 0;
    word-wrap: break-word;

    &.small {
      color: $black;
      font-size: 14px;
      font-weight: normal;
    }

    &.status-note {
      font-size: 14px;
      color: $black;
      font-weight: normal;
    }
  }
}
</style>
